import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentoNormativaService {
  private readonly nuovaNormativaDate = this.parseDate(environment.dataNuovaNormativa);

  public isUnderNewNormativa(documentDate: Date | string | null | undefined): boolean {
    const parsedDocumentDate = this.parseDate(documentDate);

    if (!parsedDocumentDate || !this.nuovaNormativaDate) {
      return true;
    }

    return parsedDocumentDate.getTime() >= this.nuovaNormativaDate.getTime();
  }

  private parseDate(value: Date | string | null | undefined): Date | null {
    if (!value) {
      return null;
    }

    const date = typeof value === 'string' ? new Date(value) : value;
    return this.isValidDate(date) ? date : null;
  }

  private isValidDate(date: Date): boolean {
    return !Number.isNaN(date.getTime());
  }
}
